import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';
import { ReactComponent as InfoIcon } from 'assets/img/icons/info-icon.svg';

/**
 * @param {Object} props
 * @param {import("utils/types").Size} props.size
 * @param {import('utils/types').Weight} props.weight
 * @param {React.ReactNode} props.children
 * @param {string} props.tooltipText
 * @param {import('utils/types').TooltipPlacement} props.tooltipPlacement
 * @param {string} props.className
 */
export default function Title({
  size = 'lg',
  weight = 'bold',
  children = '',
  tooltipText = '',
  tooltipPlacement = 'top',
  className = ''
}) {
  if (!children) return null;

  return (
    <div className={cn(styles.container, className)} data-size={size}>
      <p data-weight={weight} className={styles.title}>
        {children}
      </p>
      <If test={!!tooltipText}>
        <UiKit.Tooltip>
          <UiKit.Tooltip.Trigger>
            <InfoIcon className={styles.helpIcon} />
          </UiKit.Tooltip.Trigger>
          <UiKit.Tooltip.Content
            placement={tooltipPlacement}
            className={styles.tooltip}
          >
            {tooltipText}
          </UiKit.Tooltip.Content>
        </UiKit.Tooltip>
      </If>
    </div>
  );
}
